import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const ViewConditionsAction = ({ onClick, disabled }) => (
  <RibbonMenu
    name="conditions"
    icon="clipboard list"
    title="actions.conditions"
    onClick={onClick}
    disabled={disabled}
    className="aridhia-view-conditions-action-menu"
    message="actions.conditions"
  />
);

export default ViewConditionsAction;
